import React from "react";
import DetailExcoPusat from "../../components/organism/DetailExcoPusat";
const PageDetailExcoPusat = () => {
  return (
    <>
      <DetailExcoPusat />
    </>
  );
};

export default PageDetailExcoPusat;
